/*
 * Max 32-bit signed integer value represents ~24.86 days in milliseconds
 * this value is a maximum for setTimeout and setInterval
 * if setTimeout receives a value higher than this it will execute the callback immediately
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/setTimeout#maximum_delay_value
 */
export const maxDelay = 2147483647
